import { render } from "./subscribeVoiceSetup.vue?vue&type=template&id=0cb009d5"
import script from "./subscribeVoiceSetup.vue?vue&type=script&lang=js"
export * from "./subscribeVoiceSetup.vue?vue&type=script&lang=js"

import "./subscribeVoiceSetup.vue?vue&type=style&index=0&id=0cb009d5&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__